import { IPaginationResponse } from '@/v2/types/paging';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const PATH = {
  DASHBOARD: '/',
  LOGIN: '/login',
  CHAT_UI: '/chatui',
  CHAT_SETTINGS: '/chatsettings',
  ANALYTICS: '/analytics',
  AVATAR_SETTINGS: '/avatarsettings',
  DESIGN_SETTINGS: '/designsettings',
  URL_SETTINGS: '/urlsettings',
  CONVERSATION_HISTORY: '/conversationhistory',
  CONVERSATION_HISTORY_DETAIL: '/conversationhistory/:id',
  QUICK_REPLY: '/chatsettings/quickreply',
  EMOTION_STATES: '/chatsettings/emotionstates',
  KNOWLEDGE_DATA_STORE: '/chatsettings/knowledgedatastore',
  DETAIL_AI_SETTINGS: '/chatsettings/detailaisettings',
  MEDIA_LIBRARY: '/chatsettings/medialibrary',
  FIXED_MESSAGE: '/chatsettings/fixedmessage',
  MAKE_FORMS: '/chatsettings/makeforms',
  CREATE_FORM: '/chatsettings/makeforms/register',
  EDIT_FORM: '/chatsettings/makeforms/edit',
  BASIC_AGENT_SETTINGS: '/avatarsettings/basicagentsettings',
  VOICE_SETTINGS: '/avatarsettings/voicesettings',
  EMOTION_SETTINGS: '/avatarsettings/emotions-setting',
  EMOTIONS_LIST: '/avatarsettings/emotions-list',
  FORM_HISTORY: '/form-history',
  LINE_LOGIN: '/chatsettings/linelogin',
  ACCOUNT_LIST: '/chatsettings/linelogin/account-list',
  FORBIDDEN_URL: '/chatsettings/forbiddenurl',
  FORBIDDEN_WORD: '/chatsettings/forbiddenword',
  VOICE_MODE: '/chatsettings/voicemode',
  FAQ_SETTING: '/faqsettings',
  FAQ_SETTING_WITH_AI: '/faqsettings/withai',
  FAQ_EDIT_WITH_AI: '/faqsettings/withai/faqedit',
  FAQ_REGISTER: '/faqsettings/faqregister',
  FAQ_EDIT: '/faqsettings/faqedit',
  ACCOUNT_SETTING: '/accountsetting',
  PLAN_AND_BILLING: '/planandbilling',
  THANKYOU: '/thankyou',
  PUBLIC_SETTINGS: '/publicsettings',
  NOT_FOUND: '/404',
};

export const ITEMS_PER_PAGE_OPTIONS = [
  { value: 50, label: `50件表示 ` },
  { value: 100, label: `100件表示 ` },
  { value: 500, label: `500件表示 ` },
];

export const isDataLoadPage = (val: any) =>
  val === 'DATA_DEFAULT_FOR_LOAD_PAGE';

export enum SORT_BY {
  CREATED_AT = 'created_at',
  UPDATED_AT = 'Updated_at',
  COUNT = 'count',
}

export enum SORT_ORDER {
  DESC = 'desc',
  ASC = 'asc',
}

export const PAGE_LIMIT = 50;
export const PAGE_CURRENT = 1;

export const DEFAULT_PER_PAGE = 50;

export const SORT_OPTIONS = [
  { value: SORT_ORDER.DESC, label: '新しい順' },
  { value: SORT_ORDER.ASC, label: '古い順' },
];

export const MAX_FORMS_GENERAL = 5;

export const MAX_DESCRIPTION_LENGTH = 50;

export const AUTH_KEY = 'auth';

export const PAGINATION_DEFAULT_VALUE: IPaginationResponse = {
  total_records: 0,
  page: 1,
  limit: DEFAULT_PER_PAGE,
  sort_by: 'created_at',
  sort_order: 'desc',
};

export const enum EChatUserType {
  All = '',
  Mail = 'mail',
  Line = 'line',
}

export const loginTypes = [
  { id: EChatUserType.All, name: 'すべてのアカウント' },
  { id: EChatUserType.Line, name: 'LINEでログイン' },
  { id: EChatUserType.Mail, name: 'メールでログイン' },
];

export const chatUserTypes = [
  {
    id: EChatUserType.Mail,
    name: 'メール',
  },
  {
    id: EChatUserType.Line,
    name: 'LINE',
  },
  {
    id: EChatUserType.All,
    name: '─',
  },
];

export const CHARACTER_POSITION_CONSTANTS = {
  DEFAULT_POSITION: -100,
  DEFAULT_SIZE: 100,
  MIN_POSITION: -600,
  MAX_POSITION: 400,
  MIN_SIZE: 50,
  MAX_SIZE: 150,
};

export const KEYBOARD_EVENT = {
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  TAB: 'Tab',
  ENTER: 'Enter',
};
